import * as pdfjsLib from 'pdfjs-dist';
// Vite resolves this to a hashed URL for the pdf.js web worker bundle.
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

export { pdfjsLib };
